import React from 'react'
import Layout from '../../Layout/Layout'

const AI_low_resource = () => {
  return (
    <Layout>
        <div className='uk-container'>
            <div><h2 className='light uk-text-bold uk-margin-xlarge-top'>Low-Resource Language Models for African Languages</h2></div>
            <div className='uk-grid'>
               <div className='uk-width-1-2@s'>
                      <p className='light'>The technical study focused on developing Low-Resource
                         Language Models (LLMs) using transformer-based technology,
                          specifically targeting the diverse collection of African 
                          Indigenous Languages . This research was crucial for 
                          addressing the existing underrepresentation of these 
                          languages in the global digital space and advancing inclusive technology.</p>

                <p className='light'>The key technical finding demonstrated that innovative ensemble 
                    models—which combine predictions from multiple base models—were
                     highly effective for this task. When applied to clusters of 
                     related low-resource languages, these ensemble models successfully
                      achieved weighted F1 scores exceeding 77%. </p>
               </div>

                <div className='uk-width-1-2@s'>
                <p className='light'>This confirmed the viability of specialized, data-efficient approaches
                     for creating high-performing language models where large datasets are unavailable.</p>

                <p className='light'>The contribution of this specialized research is 
                    vital for advancing Afrocentric Natural Language Processing (NLP),
                     ensuring that AI development is rooted in the continent's linguistic
                      realities. More broadly, the development of these robust language
                       models serves as a critical step in reducing the digital divide 
                       for over two billion speakers of African languages, granting them
                        equitable access to digital technologies and services. </p>

                        <p className='light'><span className='uk-text-bold'>Contribution: </span>reducing the digital divide for
                         2+ billion speakers, advancing Afrocentric NLP.</p>
                         <p className='light'>DOI: https://doi.org/10.5281/zenodo.16786902 </p>
               </div>
            </div>
        </div>
        </Layout>
  )
}

export default AI_low_resource